window.addEventListener('DOMContentLoaded', async event => {
  const therapistSubscriptionStripeForm = document.querySelector('.subscriptions.stripe_payment');

  if (therapistSubscriptionStripeForm) {
    const stripe = Stripe(document.querySelector('#therapists-stripe-checkout-form').dataset.stripeKey);
    const stripeClientSecret = document.querySelector('#therapists-stripe-checkout-form').dataset.clientSecret;

    const fetchClientSecret = async () => {
      return stripeClientSecret;
    };

    const checkout = await stripe.initEmbeddedCheckout({
      fetchClientSecret
    });
  
    // Mount Checkout
    checkout.mount('#therapists-stripe-checkout-form');
  }
});